import React from "react";
import { Box, Typography } from "@mui/material";
import { COLORS } from "./wtStyle";

const TONE_COLOR = {
  blue: COLORS.blue,
  orange: COLORS.orange,
  red: COLORS.red,
  green: COLORS.green,
  grey: "#111827",
};

// CP-Sourcing-style stat row ("All My CPs 474 / Outreach 58 / Escalate 85 /
// Critical 195 / Never Active 0") ported to Work Transfer — same shape
// (count + label + optional hint, colored by tone), reused for both the
// "Who's work is moving" overview and the per-user dormancy breakdown so the
// two rows read as one system instead of two different designs.
//
// Selectable tiles are opt-in per tile (pass onClick) so every other caller
// (CP Sourcing, dormancy breakdown) keeps its plain read-only behavior
// unchanged. A tile with count 0 is never clickable, regardless of onClick —
// there's nothing to select — and renders visibly muted so that's clear at a
// glance rather than only on click.
export default function InsightTiles({ tiles }) {
  return (
    <Box sx={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(140px, 1fr))", gap: 1.25, mb: 2 }}>
      {tiles.map((tile, i) => {
        const isSelectable = typeof tile.onClick === "function";
        const isDisabled = isSelectable && tile.count === 0;
        const isSelected = isSelectable && !isDisabled && tile.selected;
        const toneColor = TONE_COLOR[tile.tone] || TONE_COLOR.grey;
        return (
          <Box
            key={i}
            onClick={isSelectable && !isDisabled ? tile.onClick : undefined}
            sx={{
              border: `1px solid ${isSelected ? toneColor : COLORS.border}`,
              borderRadius: 2.5,
              p: 1.5,
              bgcolor: isSelected ? `${toneColor}14` : "#fff",
              cursor: isSelectable ? (isDisabled ? "not-allowed" : "pointer") : "default",
              opacity: isDisabled ? 0.5 : 1,
              transition: "border-color 0.15s, background-color 0.15s",
              "&:hover": isSelectable && !isDisabled ? { borderColor: toneColor } : undefined,
            }}
          >
            <Typography fontSize={21} fontWeight={700} lineHeight={1.1} sx={{ color: toneColor, fontVariantNumeric: "tabular-nums" }}>
              {tile.count}
            </Typography>
            <Typography fontSize={12} fontWeight={600} sx={{ mt: 0.4 }}>
              {tile.label}
            </Typography>
            {tile.hint && (
              <Typography fontSize={11} color={COLORS.textSecondary} sx={{ mt: 0.1 }}>
                {tile.hint}
              </Typography>
            )}
          </Box>
        );
      })}
    </Box>
  );
}
